import SidePage from '@/shared/SidePage'
import { IParameter } from '../../parameters.types'
import { useState } from 'react'
import EditParameterSidePageContent from './EditParameterSidePageContent'
import ViewParameterSidePageContent from './ViewParameterSidePageContent'

interface IProps {
  open: boolean
  onClose: () => void
  parameter: IParameter
  onCloseAnimationEnd?: () => void
}

const ParameterSidePage = (props: IProps) => {
  const [pageMode, setPageMode] = useState<'view' | 'edit'>('view')

  const renderContent = () => {
    if (pageMode === 'edit') {
      return <EditParameterSidePageContent parameter={props.parameter} onCancel={() => setPageMode('view')} />
    }

    return (
      <ViewParameterSidePageContent
        parameter={props.parameter}
        onEdit={() => setPageMode('edit')}
        onClose={props.onClose}
      />
    )
  }

  return (
    <SidePage onClose={props.onClose} open={props.open} onCloseAnimationEnd={props.onCloseAnimationEnd}>
      {renderContent()}
    </SidePage>
  )
}

export default (props: IProps) => {
  if (!props.parameter) return null

  return <ParameterSidePage {...props} />
}
